/* eslint-disable @next/next/no-img-element */
import moment from "moment";
import Link from "next/link";
import React from "react";
import styles from "./FeaturedArticlesComponent.module.scss";

const FeaturedArticlesComponent = ({ items }) => {
  const url_format =
    "https://cdn.rycofilters.com/etc-squidex-assets/39f5cacb-bc68-4cc4-b4cd-4631fe4f2bcd";
//  console.log("item", items);
  const featuredItems = items
    ? items.filter((x) => x.flatData.isFeatured).slice(0, 3)
    : [];

  return (
    <div className='container'>
      <div className='text-white'>
        <div className={`${styles.gridLayout}`}>
          {featuredItems.length > 0 &&
            featuredItems.map((article, idx) => {
              const item = article.flatData;
              const img = item?.coverImage != null ? item?.coverImage[0]?.url : "";
              const selectionCss=(article.flatData.isGradientAllow===true||typeof article.flatData.isGradientAllow=="undefined"||article.flatData.isGradientAllow==null)?styles.OverlaySection:styles.OverlaySectionWithoutGradient;
              // console.log("article_selection",article.isGradientAllow);
              // const version =
              //   item?.coverImage != null ? item.coverImage[0]?.version : "";
              // const cdn = `${url_format}_${img}_${version}`;
              const bgStyle =
                item?.coverImage != null
                  ? `url(${img}) no-repeat center center`
                  : "";
              const doubleHeightCss = item.isFeaturedDoubleHeight
                ? `${styles.spanDouble}`
                : `${styles.spanSingle}`;
              const dd = moment(article.created).format("Do MMM YY");

              return (
                <div
                  className={`${styles.gridItem} ${doubleHeightCss}`}
                  key={idx}
                >
                  <div
                    className={`h-100 ${selectionCss} d-flex flex-column justify-content-start`}
                    style={{ background: bgStyle, backgroundSize: "cover" }}
                  >
                    <Link href={`/articles/${item.pageId}`} legacyBehavior>
                      <a>
                        <h3>{item.heading}</h3>
                        {item.subHeading && <p>{item.subHeading}</p>}
                        <p>RYCO FILTERS - {dd}</p>
                      </a>
                    </Link>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default FeaturedArticlesComponent;
